<template>
  <div>
    <div class="font-14 font-weight-bold">
      <span class="color-orange-light-2 mr-2">
        {{ $t('lblWizardStep1Section1Title.text') }}
        <span class="align-sub">* * *</span>
      </span>
      <span class="color-dark-blue">{{ $t('lblWizarStep1Title.text') }}</span>
    </div>
    <div v-if="!isReadOnly">
      <validation-observer ref="formRef" v-slot="{}" tag="form">
        <div class="row mt-4">
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('ApplicantFirstName') }}:
            </div>
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-input disabled class="input-display__extended" v-model="model.fullName" :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`" />
            </validation-provider>
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('ApplicantName') }}:
            </div>
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-input disabled class="input-display__extended" v-model="model.firstName" :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`" />
            </validation-provider>
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('ApplicantMiddleName') }}:
            </div>
            <validation-provider  v-slot="{ errors }">
              <custom-input disabled class="input-display__extended" v-model="model.middleName" :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`" />
            </validation-provider>
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('ApplicantLastName') }}:
            </div>
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-input disabled class="input-display__extended" v-model="model.fatherLastName" :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`" />
            </validation-provider>
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('ApplicantMaternalName') }}:
            </div>
            <custom-input disabled class="input-display__extended" v-model="model.maternalLastName" />
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('PhoneNumber') }}:
            </div>
            <custom-input disabled class="input-display__extended" v-model="model.telephone1" mask-type="Phone" />
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('Mobile') }}:
            </div>
            <custom-input disabled class="input-display__extended" v-model="model.telephone2" mask-type="Phone" />
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('Email') }}:
            </div>
            <custom-input disabled class="input-display__extended" v-model="model.email" mask-type="Email" />
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('ApplicantPostalAddress') | capitalize | empty }}
            </div>
            <custom-input disabled class="input-display__extended" v-model="model.postalAddress" />
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('ApplicantWorkPosition') }}
            </div>
            <custom-input disabled class="input-display__extended" v-model="model.workPosition" />
          </div>
          <div class="col-md-4 mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('ApplicantWorkPlace') }}
            </div>
            <custom-input disabled class="input-display__extended" v-model="model.workPlace" />
          </div>
        </div>
      </validation-observer>
    </div>
    <div v-else>
      <div class="mt-4">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="color-gray-18 font-14">
              {{ $t('ApplicantFirstName') }}:
            </div>
            <span class="color-black font-14">{{ info.fullName }}</span>
          </div>
          <div class="col-12 col-md-4">
            <div class="color-gray-18 font-14">
              {{ $t('ApplicantName') }}:
            </div>
            <span class="color-black font-14">{{ info.firstName }}</span>
          </div>
          <div class="col-12 col-md-4">
            <div class="color-gray-18 font-14">
              {{ $t('ApplicantMiddleName') }}:
            </div>
            <span class="color-black font-14">{{ info.middleName }}</span>
          </div>
          <div class="col-12 col-md-4">
            <div class="color-gray-18 font-14">
              {{ $t('ApplicantLastName') }}:
            </div>
            <span class="color-black font-14">{{ info.fatherLastName }}</span>
          </div>
          <div class="col-12 col-md-4">
            <div class="color-gray-18 font-14">
              {{ $t('ApplicantMaternalName') }}:
            </div>
            <span class="color-black font-14">
              {{ info.mothersLastname }}
            </span>
          </div>
        </div>
        <div class="mt-4">
          <span class="color-black-2 font-weight-bold font-14">
            {{ $t('ContactInformation') | upper }}
          </span>
          <div class="row mt-2">
            <div class="col-12 col-md-4">
              <div class="color-gray-18 font-14">{{ $t('Mobile') }}:</div>
              <span class="color-black font-14">
                {{ info.cellphone | empty }}
              </span>
            </div>
            <div class="col-12 col-md-4">
              <div class="color-gray-18 font-14">{{ $t('PhoneNumber') }}:</div>
              <span class="color-black font-14">
                {{ info.phone }}
              </span>
            </div>
            <div class="col-12 col-md-4">
              <div class="color-gray-18 font-14">{{ $t('Email') }}:</div>
              <span class="color-black font-14">
                {{ info.email }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <span class="color-black-2 font-weight-bold font-14">
          {{ $t('AddressInformation') | upper }}
        </span>
        <div class="row mt-2">
          <div class="col-12 col-md-4">
            <div class="color-gray-18 font-14">
              {{ $t('ApplicantPostalAddress') | capitalize }}
            </div>
            <span class="color-black font-14">
              {{ info.postalAddress | empty }}
            </span>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <span class="color-black-2 font-weight-bold font-14">
          {{ $t('PositionInformation') | upper }}
        </span>
        <div class="row mt-2">
          <div class="col-12 col-md-4">
            <div class="color-gray-18 font-14">
              {{ $t('ApplicantWorkPosition') }}
            </div>
            <span class="color-black font-14">
              {{ info.jobPosition | empty }}
            </span>
          </div>
          <div class="col-12 col-md-4">
            <div class="color-gray-18 font-14">
              {{ $t('ApplicantWorkPlace') }}
            </div>
            <span class="color-black font-14">
              {{ info.companyName | empty }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProfileInformation as _getApplicantInformation } from '@/services/app.api.js';

//libs
import CustomInput from 'CustomInput';

export default {
  name: 'ApplicantInformation',
  components: {
    CustomInput,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => { },
    }
    
  },
  data() {
    return {
      model: {
        fullName: null,
        fatherLastName: null,
        maternalLastName: null,
        telephone1: null,
        telephone2: null,
        email: null,
        postalAddress: null,
        workPosition: null,
        workPlace: null,
      },
    };
  },
  async mounted() {
    
    if (!this.isReadOnly) {
      await this.getApplicantInformation();
    }
  },
  methods: {
    async getApplicantInformation() {
      const modelInfo = (await _getApplicantInformation()).data;
      this.model = {
        ...modelInfo,
        fatherLastName: modelInfo.lastName,
      };

      const postalAddress = modelInfo.postalAddress;

      this.model.postalAddress = [
        postalAddress.address1,
        postalAddress.address2,
        postalAddress.address3,
        postalAddress.city?.name,
        postalAddress.zipCode && ` ${postalAddress.zipCode}`,
      ]
        .filter(Boolean)
        .join(' ')
        .trim();
    },
    getModel() {
      return { ...this.model };
    },
    setModel(value) {
      this.model = {
        ...this.model,
        ...value,
      };
    },
    async validate() {
      return await this.$refs.formRef.validate();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';

::v-deep.input-display__extended {
  .input-display {
    margin-left: unset;
    border: 1px solid map-get($colors, 'gray-25');
    border-radius: 0.25rem;
    padding: 6px 10px;
    color: map-get($colors, 'gray-24');
    background: map-get($colors, 'white');
  }
}
</style>
